<template>
    <div :class="['block-socials', { 'grid-container': isGrid }]" :style="{ justifyContent: content.position }">
        <social-btn
            :button="btn"
            :key="n"
            :display-type="content.displayType"
            class="block-socials__item"
            v-for="(btn, n) of content.list"
        />
    </div>
</template>

<script>
import SocialBtn from "../common/SocialBtn";

export default {
    name: "TapSocial",
    components: {
        SocialBtn
    },
    props: {
        content: {}
    },
    computed: {
        isGrid() {
            return ["compact", "circle"].includes(this.content.displayType);
        }
    }
};
</script>

<style lang="scss" scoped>
.block-socials {
    .block-socials__item {
        margin-bottom: 14px;
        &:last-child {
            margin-bottom: 0;
        }
    }
}
.grid-container {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    .block-socials__item {
        margin-bottom: 0;
    }
}
</style>
